
import { ReferencedEntry } from 'contentful';

import { SalesChannel, ShopContentType, SpeedBumpReseller } from 'src/api/contentful/contentTypes.shop';
import { fetchEntries } from 'src/api/contentful/fetchEntries';
import { get, getField, getSys, isEntry } from 'src/utils/EntryUtil';
import { Environment } from 'src/utils/Environment';

import { ValidationState } from './ValidationState';

export type PartnerInfo = {
  state: ValidationState;
  entry?: ReferencedEntry<SalesChannel>;
  redirectUrl?: string;
};

export async function fetchPartnerInfo(locale: string, referrerDomains: string, api = Environment.current.shopContentApi): Promise<PartnerInfo> {
  const salesChannels = await fetchEntries<SalesChannel>(locale, {
    contentType: ShopContentType.SALES_CHANNEL,
    filters: { fields: { referrerDomains } },
    select: { sys: 'id', fields: [ 'referrerDomains' ] },
    limit: 1,
  }, api);

  const salesChannel = get(salesChannels, 'items', [])[0] as ReferencedEntry<SalesChannel>;

  if (!isEntry(salesChannel)) return { state: ValidationState.INVALID };

  const resellers = await fetchEntries<SpeedBumpReseller>(locale, {
    contentType: ShopContentType.SPEED_BUMP_RESELLER,
    filters: { fields: { salesChannel: { sys: { id: getSys(salesChannel, 'id') } } } },
    select: { sys: 'id', fields: [ 'externalRedirectUrl' ] },
    limit: 1,
  }, api);

  const reseller = get(resellers, 'items', [])[0] as ReferencedEntry<SpeedBumpReseller>;

  const redirectUrl = getField(reseller, 'externalRedirectUrl');

  if (redirectUrl) return { state: ValidationState.REDIRECT, redirectUrl };

  return { state: ValidationState.VALID, entry: salesChannel };
}
